import { HugeiconsIcon } from "@hugeicons/react";
import { AlertCircleIcon, ReloadIcon } from "@hugeicons-pro/core-bulk-rounded";

import { Component, type ReactNode } from "react";

import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

/** Friendly fallback shown when a data query fails on initial load. */
function ErrorCard({ onRetry }: { onRetry: () => void }) {
  return (
    <Card className="mx-auto mt-10 max-w-md p-8 text-center">
      <HugeiconsIcon icon={AlertCircleIcon} size={32} />
      <h2 className="mt-3 font-heading text-lg font-semibold">Er ging iets mis</h2>
      <p className="mt-1 text-sm text-muted-foreground">
        We konden de gegevens niet laden. Probeer het opnieuw.
      </p>
      <Button variant="outline" size="sm" onClick={onRetry} className="mt-4 gap-1.5">
        <HugeiconsIcon icon={ReloadIcon} size={16} />
        Opnieuw proberen
      </Button>
    </Card>
  );
}

interface Props {
  /** Called when the user retries — reset the query cache so it refetches. */
  onReset?: () => void;
  children: ReactNode;
}

export class ErrorBoundary extends Component<Props, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  reset = () => {
    this.props.onReset?.();
    this.setState({ error: null });
  };

  render() {
    if (this.state.error) return <ErrorCard onRetry={this.reset} />;
    return this.props.children;
  }
}
